/// <amd-module name="typeahead/features/EnableMultiregionFlightsTypeahead.ts" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestServiceParamModifier} from "typeahead/core/SuggestServiceParamModifier";

export class EnableMultiregionFlightsTypeahead extends SuggestServiceParamModifier
    implements IExperimentalFeature, IRequestUrlParamModifier  {

    public featureName: string = "EnableMultiregionFlightsTypeahead";

    public configuration: IStripingConfiguration[] = [
        {
            experiment: {
                id: 33979,
                name: "EnableMultiregionFlightsTypeahead",
                value: 1,
            },
            lobs: ["FLIGHTS"],
        },
    ];

    public modify(params: ISuggestServiceQueryParams, context: IContext, options: any) {
        this.addRegionType(params, 256);
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(this.configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        if (ExecutionHelper.shouldExecute(context, this.configuration)) {
            this.modify(params, context, options);
        }
        return params;
    }
}
